module.exports = __webpack_public_path__ + "img/icon-payment-generic.5f93c1a7.svg";